import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, change } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'
import { renderInputField, renderSelectField } from '../utils/forms'

import { repairFault } from '../actions/faults'

class RemoteActionFaultRepairForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      actionCompleted: false,
      errorMessage: '',
      repairType: '',
      materials: {
        LOCK_MAIN: false,
        LOCK_PINPAD: false,
        LOCK_ANCHORAGE: false,
        LOCK_PLATEN: false,
        LOCK_NUMBER: false,
        BATTERIES: false,
        HINGE: false,
        USB_WIRE: false,
        NO_MATERIAL: false,
        DOOR: false,
      }
    }

    this.submit = this.submit.bind(this)
    this.handleMaterialSelect = this.handleMaterialSelect.bind(this)
  }

  componentDidMount() {
    // Materials: LOCK_MAIN, LOCK_PINPAD, LOCK_ANCHORAGE, LOCK_PLATEN, LOCK_NUMBER, BATTERIES, HINGE, USB_WIRE, NO_MATERIAL, DOOR
  }

  handleMaterialSelect(material) {
    this.setState(prevState => {
      let updatedMaterials = { ...prevState.materials }

      if (material === 'NO_MATERIAL') {
        // If NO_MATERIAL is selected, deselect all other materials
        updatedMaterials = {
          LOCK_MAIN: false,
          LOCK_PINPAD: false,
          LOCK_ANCHORAGE: false,
          LOCK_PLATEN: false,
          LOCK_NUMBER: false,
          BATTERIES: false,
          HINGE: false,
          USB_WIRE: false,
          NO_MATERIAL: true,
          DOOR: false,
        }
      } else {
        // If any other material is selected, ensure NO_MATERIAL is deselected
        updatedMaterials.NO_MATERIAL = false
        updatedMaterials[material] = !prevState.materials[material]
      }

      return { materials: updatedMaterials }
    })
  }

  submit = async (props) => {
    const { materials } = this.state
    const { reset } = this.props;
    
    if (!Object.values(materials).some(material => material)) {
      this.setState({ errorMessage: 'Por favor, selecciona al menos un material.' });
      throw new SubmissionError({ _error: 'Por favor, selecciona al menos un material.' });
    }

    this.setState({ loading: true, actionCompleted: false })

    // Prepare replacementsUsed object
    let replacementsUsed = {
      LOCK_MAIN: materials.LOCK_MAIN,
      LOCK_PINPAD: materials.LOCK_PINPAD,
      LOCK_ANCHORAGE: materials.LOCK_ANCHORAGE,
      LOCK_PLATEN: materials.LOCK_PLATEN,
      LOCK_NUMBER: materials.LOCK_NUMBER,
      BATTERIES: materials.BATTERIES,
      HINGE: materials.HINGE,
      USB_WIRE: materials.USB_WIRE,
      NO_MATERIAL: materials.NO_MATERIAL,
      DOOR: materials.DOOR,
    }

    props.Locker = this.props.lockerSN
    props.Replacements = replacementsUsed

    try {
      const response = await this.props.repairFault(props)

      if (response.error) {
        throw new SubmissionError({
          _error: response.error.message,
          ...response.error.fields
        })
      }

      this.setState({ loading: false, actionCompleted: true })

      // Trigger matrix data refresh
      if (this.props.refreshMatrixData) {
        this.props.refreshMatrixData();
      }
      reset();
      return response
    } catch (error) {
      this.setState({ loading: false, errorMessage: error.message || 'Error processing action' })
      throw error
    }
  }

  getMaterialName(MaterialCode) {
    switch (MaterialCode) {
      case 'LOCK_MAIN':
        return "Centralita"
      case 'LOCK_PINPAD':
        return "Teclado"
      case 'LOCK_ANCHORAGE':
        return "Pincho"
      case 'LOCK_PLATEN':
        return "Pletina"
      case 'LOCK_NUMBER':
        return "Número"
      case 'USB_WIRE':
        return "Cable USB"
      case 'BATTERIES':
        return "Pilas (pack 4)"
      case 'HINGE':
        return "Bisagra"
      case 'DOOR':
        return "Puerta"
      case 'DOOR_BNS':
        return "Puerta Standard"
      case 'DOOR_BWS':
        return "Puerta Standard XL"
      case 'DOOR_BNM':
        return "Puerta Medium"
      case 'DOOR_BWM':
        return "Puerta Medium XL"
      case 'DOOR_BNL':
        return "Puerta Large"
      case 'DOOR_BWL':
        return "Puerta Large XL"
      default:
        return "Ajuste sin material"
    }
  }

  render() {
    const { error, pristine, submitting, handleSubmit } = this.props
    const { loading, actionCompleted, materials } = this.state

    if (loading) {
      return (
        <div className="lm-state">
          <span className="lm-state-msg">Ejecutando reparación...</span>
          <LoadingProgress logoHeight={36} className="compact" />
        </div>
      )
    }

    if (actionCompleted) {
      return (
        <div className="lm-alert-stack">
          <div className="lm-alert lm-alert-success">Reparación registrada correctamente</div>
        </div>
      )
    }

    return (
      <div>
        <form onSubmit={handleSubmit(this.submit)}>
          <div className="lm-fault-grid">
            {['LOCK_MAIN', 'LOCK_PINPAD', 'LOCK_ANCHORAGE', 'LOCK_PLATEN', 'LOCK_NUMBER', 'BATTERIES', 'HINGE', 'USB_WIRE', 'DOOR'].map(material => (
              <button
                key={material}
                type="button"
                className={`lm-fault-btn ${materials[material] ? 'lm-fault-btn-repair-selected' : ''}`}
                onClick={() => this.handleMaterialSelect(material)}
              >
                <img src={`/images/repairs/${material}.png`} alt={material} />
                <p>{this.getMaterialName(material)}</p>
              </button>
            ))}

            <button
              type="button"
              className={`lm-fault-btn ${materials.NO_MATERIAL ? 'lm-fault-btn-repair-selected' : ''}`}
              onClick={() => this.handleMaterialSelect('NO_MATERIAL')}
            >
              <img src="/images/repairs/cross.png" alt="NO_MATERIAL" />
              <p>Ajuste sin material</p>
            </button>
          </div>

          {/* Submit button */}
          <div className="lm-form-footer">
            <button className="lm-btn-cancel" type="button" onClick={this.props.closeMatrixDialog}>
              Cancelar
            </button>
            <button className="lm-btn-confirm" type="submit" disabled={submitting || Object.values(materials).every(v => v === false)}>
              <i className="fas fa-bolt"></i>Confirmar reparación
            </button>
          </div>

          {/* Error message */}
          {error && <div className="lm-alert-stack">
            <div className="lm-alert lm-alert-danger">{error}</div>
          </div>}
        </form>
      </div>
    )
  }
}

RemoteActionFaultRepairForm = reduxForm({
  form: 'RemoteActionFaultRepairForm',
})(RemoteActionFaultRepairForm)

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
  formValues: state.form.RemoteActionFaultRepairForm && state.form.RemoteActionFaultRepairForm.values,
})

const mapDispatchToProps = dispatch => ({
  repairFault: bindActionCreators(repairFault, dispatch),
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(RemoteActionFaultRepairForm)
